import { useState } from 'react';

import { readStored, writeStored } from './storage.ts';

// For per-browser view preferences only.
const useLocalStorageState = <T extends string>(key: string, defaultValue: T, allowedValues: readonly T[]) => {
    const [value, setValue] = useState<T>(() => {
        const stored = readStored(key);
        return allowedValues.includes(stored as T) ? (stored as T) : defaultValue;
    });

    const setStoredValue = (nextValue: T) => {
        setValue(nextValue);
        writeStored(key, nextValue);
    };

    return [value, setStoredValue] as const;
};

export default useLocalStorageState;
